import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzModalModule, NzModalRef } from 'ng-zorro-antd/modal';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';

export enum ShiftAccessRightConfirmationModalResult {
  ProceedAnyway = 'proceed_anyway',
  UpdateShift = 'update_shift',
}

@Component({
  selector: 'wilson-shift-access-right-confirmation-modal',
  imports: [NzModalModule, TranslateModule, NzTooltipModule, NzButtonModule],
  templateUrl: './shift-access-right-confirmation-modal.component.html',
  styleUrls: ['./shift-access-right-confirmation-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShiftAccessRightConfirmationModalComponent {
  private modalRef = inject(NzModalRef);

  handleCancel(): void {
    this.modalRef.destroy(null);
  }

  handleProceedAnyway(): void {
    this.modalRef.destroy(
      ShiftAccessRightConfirmationModalResult.ProceedAnyway,
    );
  }

  handleUpdateShift(): void {
    this.modalRef.destroy(ShiftAccessRightConfirmationModalResult.UpdateShift);
  }
}
